import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { FOLLOW_UP_TASK_ACTIONS } from "../../enum";
import { FOLLOW_UP_COLLECTION_WRITE_PERMISSION } from "../../../enum";

const { EDIT_FOLLOW_UP_TASK, DELETE_FOLLOW_UP_TASK } = FOLLOW_UP_TASK_ACTIONS;

const FollowUpTasksViewActions = ({ handleActionModal, followUpTask }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal?.(value, followUpTask)}
            options={[
                {
                    value: EDIT_FOLLOW_UP_TASK,
                    label: "Edit",
                    baseResources: FOLLOW_UP_COLLECTION_WRITE_PERMISSION,
                },
                {
                    value: DELETE_FOLLOW_UP_TASK,
                    label: "Delete",
                    baseResources: FOLLOW_UP_COLLECTION_WRITE_PERMISSION,
                },
            ]}
        />
    );
};

export default FollowUpTasksViewActions;
